import { render, staticRenderFns } from "./couponShopPoolDetailManage.vue?vue&type=template&id=b2241fc0&scoped=true"
import script from "./couponShopPoolDetailManage.vue?vue&type=script&lang=js"
export * from "./couponShopPoolDetailManage.vue?vue&type=script&lang=js"
import style0 from "./couponShopPoolDetailManage.vue?vue&type=style&index=0&id=b2241fc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2241fc0",
  null
  
)

export default component.exports